import Badge from "../common/Badge";
import Button from "../common/Button";
import EmptyState from "../common/EmptyState";
import { getCampaignStatusMeta } from "../../utils/helpers";

export default function CampaignList({
  campaigns,
  loading,
  onCreate,
  onView,
  onDelete,
}) {
  return (
    <div>
      <div className="section-row">
        <div className="section-title section-title-no-margin">Campaigns</div>
        <Button variant="gold" onClick={onCreate}>
          + New Campaign
        </Button>
      </div>

      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Campaign</th>
              <th>Status</th>
              <th>Progress</th>
              <th>Answered</th>
              <th>Interested</th>
              <th>Booked</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7">
                  <div className="empty-state">Loading campaigns...</div>
                </td>
              </tr>
            ) : !campaigns.length ? (
              <tr>
                <td colSpan="7">
                  <EmptyState
                    icon="🚀"
                    title="No campaigns available"
                    subtitle="Create one to get started."
                  />
                </td>
              </tr>
            ) : (
              campaigns.map((campaign) => {
                const status = getCampaignStatusMeta(campaign.status);
                const percentage = campaign.total_targets
                  ? Math.round((campaign.calls_made / campaign.total_targets) * 100)
                  : 0;

                return (
                  <tr key={campaign.id}>
                    <td>
                      <strong>{campaign.name}</strong>
                      <br />
                      <span className="micro-copy">
                        {(campaign.offer_message || "").slice(0, 60)}
                      </span>
                      {campaign.scheduled_at && campaign.status === "scheduled" && (
                        <><br /><span className="micro-copy muted-text">
                          ⏰ {new Date(campaign.scheduled_at).toLocaleString()}
                        </span></>
                      )}
                    </td>
                    <td>
                      <Badge variant={status.variant}>{status.label}</Badge>
                    </td>
                    <td>{`${campaign.calls_made}/${campaign.total_targets} (${percentage}%)`}</td>
                    <td>{campaign.calls_answered}</td>
                    <td>{campaign.calls_interested}</td>
                    <td>{campaign.calls_booked}</td>
                    <td className="campaign-actions-cell">
                      <Button
                        className="compact-btn"
                        onClick={() => onView(campaign.id)}
                      >
                        View
                      </Button>
                      {["draft", "scheduled", "completed", "cancelled"].includes(campaign.status) ? (
                        <Button
                          variant="danger"
                          className="compact-btn"
                          onClick={() => onDelete(campaign.id)}
                        >
                          Delete
                        </Button>
                      ) : null}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
